import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { hasClass } from '@opten/dom/has-class';

import {getParentWithClass} from '@opten/dom/get-parent-with-class';

import { fitBoundsWithPadding } from '@opten/map-helpers/fit-bounds-with-padding';
import { isMobile } from '../../utilities/detection';
import {addTransitionEndListener} from '@opten/transition/add-transition-end-listener';

declare const require: any;
let _SnazzyInfoWindow: any = null;
function getSnazzyInfoWindow(): any {
	if (_SnazzyInfoWindow == null) {
		const mod = require('snazzy-info-window/dist/snazzy-info-window.min.js');
		_SnazzyInfoWindow = (mod && mod.default) ? mod.default : mod;
	}
	return _SnazzyInfoWindow;
}

class MapsLocation {
	marker: google.maps.Marker;
	className: any;
	constructor(element, className) {
		this.marker = element;
		this.className = className;
	}
}
declare class OverlappingMarkerSpiderfier {
	constructor(map: any, options: any);
	addMarker(marker: any);
	removeMarker(marker: any);
}
declare class MarkerClusterer {
	constructor(map: any, opt_markers: any, opt_options: any);
	addMarker(marker: any);
	removeMarker(marker: any);
	clearMarkers();

}

export interface MapExtendedOptions {
	zoom?: number;
	draggable?: boolean;
	urlLocation?: string;
	urlDatacenter?: string;
	animation?: google.maps.Animation;
	mapStyles?: any;
	styledMapName?: string;
	mapMarkerClasses?: string[];
	showMapMarkerClasses?: string[];
	hasMapMarkerClassesButtonIfMultiple?: boolean;
	mapMarkerClassesButtonActiveClass?: string;
	mapMarkerInfoClass?: string;
	mapTypes?: google.maps.MapTypeId[];
	mapTypeControlStyle?: google.maps.MapTypeControlStyle;
	mapCenter?: {
		lat: number;
		lng: number;
	};
	clusterStyle?: {
		url: string;
		height: number;
		width: number;
		textColor: string;
	};
	fitToBounds?: boolean;
	zipInputClass?: string;
	locationInputClass?: string;
	searchClass?: string;
	searchContainerClass?: string;
	maxZoom?: number;
	wrapperClass?: string;
	sidePanelWrapperClass?: string;
	sidePanelClass?: string;
	sidePanelCloseClass?: string;
}
export class MapExtended {


	private _options: MapExtendedOptions = {
		draggable: screen.width < 1025 === false,		
		animation: undefined,
		mapStyles: null,
		mapMarkerClasses: ['map-location'],
		showMapMarkerClasses: ['map-location'],
		hasMapMarkerClassesButtonIfMultiple: false,
		mapMarkerClassesButtonActiveClass: 'is-active',
		mapMarkerInfoClass: 'c-map-extended__information__marker',
		mapTypes: [],
		maxZoom: 11,
		mapCenter: { lat: 46.905358, lng: 8.423689 },
		mapTypeControlStyle: undefined,
		fitToBounds: true,
		clusterStyle: {
			url: '/assets/map-cluster.png',
			height: 54,
			width: 54,
			textColor: 'white'
		},
		zipInputClass: 'js-map-searcher-zip',
		locationInputClass: 'js-map-searcher-location',
		searchClass: 'js-map-search',
		searchContainerClass: 'js-map-searcher-container',
		wrapperClass: 'js-map-extended-wrapper',
		sidePanelWrapperClass: 'js-map-extended-side-panel-wrapper',
		sidePanelClass: 'js-map-extended-side-panel',
		sidePanelCloseClass: 'js-map-extended-side-panel-close'
	};
	private _locations = Array<MapsLocation>();
	private _element: HTMLElement;
	private _sidePanelWrapper: HTMLElement;
	private _sidePanelElements: HTMLElement[];
	private _currentInfoWindow = null;
	private _currentInfoWindowClickOpened = false;
	private _bounds: google.maps.LatLngBounds;
	private _mapWrapper: HTMLElement;
	private _map: google.maps.Map;
	private _oms: OverlappingMarkerSpiderfier;
	private _markerCluster: MarkerClusterer;
	private _geoCoder: google.maps.Geocoder;
	private _previousZip: string;
	private _previousLocation: string;
	private _previousBounds: google.maps.LatLngBounds;
	private _zipSearchField: HTMLInputElement;
	private _locationSearchField: HTMLInputElement;

	private _searchField: HTMLElement;
	private _searchContainer: HTMLElement;
	private _searchClose: HTMLElement;
	private _fitBoundsToSearchContainer = false;
	private _maxRadiusSearch = 75;
	private _minRadiusSearch = 10;
	private _currentMapZoom = 15;
	private _enableShowAllLocationsZoomOut = true;

	constructor(element: HTMLElement, options: MapExtendedOptions) {
		this._element = element;
		this._options = { ...this._options, ...options };		
		if (this._options.animation == null && typeof google === 'object' && typeof google.maps === 'object') {
			this._options.animation = google.maps.Animation.DROP;
		}
		if (this._options.mapTypeControlStyle == null && typeof google === 'object' && typeof google.maps === 'object') {
			this._options.mapTypeControlStyle = google.maps.MapTypeControlStyle.HORIZONTAL_BAR;
		}
		this._zipSearchField = element.querySelector(
			`.${this._options.zipInputClass}`
		);
		this._locationSearchField = element.querySelector(
			`.${this._options.locationInputClass}`
		);
		this._searchField = element.querySelector(
			`.${this._options.searchClass}`
		);
		
		const wrapper = getParentWithClass(element, this._options.wrapperClass);
		this._sidePanelWrapper= wrapper.querySelector(
			`.${this._options.sidePanelWrapperClass}`
		);
		this._sidePanelElements = Array.from( wrapper.getElementsByClassName(this._options.sidePanelClass)) as HTMLElement[];
		this._searchContainer = element.querySelector(
			`.${this._options.searchContainerClass}`
		);
		if(this._searchContainer){
			this._searchClose = element.querySelector(
				`.js-side-panel-close`
			);
		}
		if (this._searchContainer && this._searchContainer.hasAttribute("data-fit-bounds") && this._searchContainer.getAttribute("data-fit-bounds") === "true") {
			this._fitBoundsToSearchContainer = true;
		}
		
		this.init();
		window.addEventListener('resize', () => this.handleResize());

	}
	private init() {
		if(this._sidePanelElements && this._sidePanelElements.length > 0){
			this._sidePanelElements.forEach(sidePanel => {
				const closeButton = sidePanel.querySelector(`.${this._options.sidePanelCloseClass}`);
				if(closeButton){
					closeButton.addEventListener('click',(e) => {
						e.preventDefault();
						this.showFullMapCloseSidePanel();
						this.hideSidePanel(sidePanel)
					});
				}
			});
		}

		if (typeof google === 'object' && typeof google.maps === 'object') {
			this.initMap()
			this.initMapMarkers();
			if (this._options.fitToBounds) {
				this._map.fitBounds(this._bounds);
			}
			if (this._options.hasMapMarkerClassesButtonIfMultiple &&
				this._options.mapMarkerClasses.length > 1) {
				this._options.mapMarkerClasses
					.map(markerClass => document.getElementById(markerClass))
					.filter(markerElement => markerElement != null)
					.forEach(markerElement => markerElement.addEventListener('click', () => this.showHideMapMarkerClass(markerElement)));
			}
		}
		else {
			console.error('Google Maps API is not included');
		}
	}

	private initMap() {
		const id = this._element.getAttribute('data-map-id');
		const zoom = this._element.getAttribute('data-zoom');
		let mapZoom;
		if (typeof zoom == 'undefined' || zoom == null) {
			mapZoom = this._options.zoom;
		}
		else {
			mapZoom = zoom;
		}
		this._bounds = new google.maps.LatLngBounds();
		const mapTypes: any = this._options.mapTypes;
		if (this._options.mapStyles != null) {
			mapTypes.push('map_style');
		}
		const mapOptions = this._options.mapStyles != null ? {
			zoom: +mapZoom,
			center: this._options.mapCenter,
			draggable: true,
			mapTypeControl: false,
			streetViewControl: false,
  			fullscreenControl: false
		} : {
			zoom: +mapZoom,
			center: this._options.mapCenter,
			draggable: true,
			mapTypeControlOptions: {
				mapTypeIds: this._options.mapTypes,
				style: this._options.mapTypeControlStyle
			}
		};
		const mapElement= document.getElementById(id);
		this._mapWrapper = mapElement.parentElement;
		this._map = new google.maps.Map(mapElement, mapOptions);
		if (this._options.mapStyles != null) {
			const nameMap = this._options.styledMapName != null
				? this._options.styledMapName
				: 'Map';
			const styledMap = new google.maps.StyledMapType(this._options.mapStyles, { name: nameMap });
			this._map.mapTypes.set('map_style', styledMap);
			this._map.setMapTypeId('map_style');
		}
		if (mapZoom != null && mapZoom > 0) {
			google.maps.event.addListenerOnce(this._map, 'idle', () => {
				this._map.setZoom(+mapZoom);
			});

		}
		this._map.addListener('zoom_changed', () => {
			const newZoom = this._map.getZoom();
			if(this._enableShowAllLocationsZoomOut){
				if(this._currentMapZoom > newZoom){
					this.showOnlyLocationsWithCurrentFilter();
				}
			}
			this._currentMapZoom = newZoom;
		});
		this._oms = new OverlappingMarkerSpiderfier(this._map, {
			markersWontMove: true,
			markersWontHide: true,
			basicFormatEvents: true,
			circleFootSeparation: 50
		});

		this._markerCluster = new MarkerClusterer(this._map, [], {
			maxZoom: this._options.maxZoom,
			styles: [this._options.clusterStyle]
		});
		
		google.maps.event.addListenerOnce(this._map, 'idle', () => this.guardMarkerClustererGetBounds());

		this._geoCoder = new google.maps.Geocoder();
	}

	private guardMarkerClustererGetBounds() {
		try {
			const clusters = (this._markerCluster as any).f;
			if (!clusters || clusters.length === 0) {
				return;
			}
			const clusterProto = Object.getPrototypeOf(clusters[0]);
			if (clusterProto.__opten_getBoundsGuarded) {
				return;
			}
			const originalGetBounds = clusterProto.getBounds;
			clusterProto.getBounds = function () {
				if (!this.a || this.a.length === 0) {
					return new google.maps.LatLngBounds();
				}
				return originalGetBounds.call(this);
			};
			clusterProto.__opten_getBoundsGuarded = true;
		} catch (err) {
			console.warn('Could not guard MarkerClusterer.getBounds', err);
		}
	}

	private initMapMarkers() {
		if (this._options.mapMarkerClasses != null &&
			this._options.mapMarkerClasses.length > 0) {
			this._options.mapMarkerClasses.forEach(markerClass => {
				const markersClass = Array.from(this._element.getElementsByClassName(markerClass));
				if (markersClass.length > 0) {
					const showMarker = this._options.showMapMarkerClasses.indexOf(markerClass) > -1;
					markersClass.forEach(markerClassInfo => this.createMarkerClass(markerClassInfo, markerClass, this._map, showMarker));
				}
				if (this._zipSearchField && this._locationSearchField) {
					this._zipSearchField.addEventListener(
						'keyup',
						(e) => this.handleKeyUpSearch(e)
					);
					this._locationSearchField.addEventListener(
						'keyup',
						(e) => this.handleKeyUpSearch(e)
					);
					if (this._searchField) {
						this._searchField.addEventListener(
							'click',
							() => this.search()
						);
					}
				}

			});
		}
	}

	private handleKeyUpSearch(event: KeyboardEvent) {
		if (event.which === 13 || event.keyCode === 13 || event.key === "Enter") {
			this.search();
		}
	}

	private createMarkerClass(markerClassInfo, markerClass, map, showMarker) {
		const markerInfoData = markerClassInfo;
		const dataCoordinates = markerInfoData.getAttribute('data-coordinates');
		const latlng = dataCoordinates.replace(' ', '').split(',');

		const mapMarkerIcon = markerInfoData.getAttribute('data-marker');
		const mapMarkerWidth = markerInfoData.getAttribute('data-marker-width');
		const mapMarkerHeight = markerInfoData.getAttribute('data-marker-height');
		const mapMarkerOriginX = markerInfoData.getAttribute('data-marker-origin-x');
		const mapMarkerOriginY = markerInfoData.getAttribute('data-marker-origin-y');
		const mapMarkerAnchorX = markerInfoData.getAttribute('data-marker-anchor-x');
		const mapMarkerAnchorY = markerInfoData.getAttribute('data-marker-anchor-y');
		const infoWindowLeft = markerInfoData.getAttribute('data-info-window-left');
		const sidePanel = markerInfoData.getAttribute('data-side-panel');

		const mapMarkerInfoArray = Array.from(markerInfoData.getElementsByClassName(this._options.mapMarkerInfoClass));
		let mapMarkerInfo = '';
		if (mapMarkerInfoArray.length > 0) {
			mapMarkerInfo = markerInfoData.innerHTML;
		}
		this.createMapLocation(latlng[0], latlng[1], mapMarkerIcon, mapMarkerWidth, mapMarkerHeight, mapMarkerOriginX, mapMarkerOriginY, mapMarkerAnchorX, mapMarkerAnchorY, mapMarkerInfo, map, showMarker, markerClass, infoWindowLeft, sidePanel);
	}
	private createMapLocation(lat, lng, mapMarkerIcon, mapMarkerWidth, mapMarkerHeight, mapMarkerOriginX, mapMarkerOriginY, mapMarkerAnchorX, mapMarkerAnchorY, mapMarkerInfo, map, showMarker, markerClass, infoWindowLeft, sidePanel) {
		const marker = new google.maps.Marker({
			position: new google.maps.LatLng(+lat, +lng),
			map: map,
			icon: {
				size: new google.maps.Size(+mapMarkerWidth, +mapMarkerHeight),
				origin: new google.maps.Point(+mapMarkerOriginX, +mapMarkerOriginY),
				anchor: new google.maps.Point(+mapMarkerAnchorX, +mapMarkerAnchorY),
				url: mapMarkerIcon
			},
			visible: showMarker
		});
		if (showMarker) {
			this._oms.addMarker(marker);
			this._markerCluster.addMarker(marker);
		}
		const matchingSidePanels = sidePanel && this._sidePanelElements ? this._sidePanelElements.filter(o => o.id === sidePanel) : null;
		this._bounds.extend(marker.getPosition());
		if (mapMarkerInfo !== '') {
			const SnazzyInfoWindowCtor = getSnazzyInfoWindow();
			const infoWindow = new SnazzyInfoWindowCtor({
				offset: {
					top: '-20px',
					left: infoWindowLeft
				  },
				marker: marker,
				content: mapMarkerInfo,
				openOnMarkerClick: false,
				callbacks: {
					afterClose: () => {
						this._currentInfoWindow = null;
					}
				}
			});
			marker.addListener('click', () => {
				const wasCurrentWindow = this._currentInfoWindowClickOpened &&  this._currentInfoWindow != null && this._currentInfoWindow === infoWindow;
				if(this._currentInfoWindowClickOpened == false){
					this._currentInfoWindowClickOpened = true;
					if(matchingSidePanels){
						matchingSidePanels.forEach(o => this.showSidePanel(o));
						addClass(this._sidePanelWrapper,'has--subpanel-open');
						if(isMobile()){
							addClass(this._mapWrapper,'is-map--small');
							map.setCenter(marker.getPosition());  
							map.setZoom(12);
							addClass(this._searchContainer,'d-none');							
						}
					}
				}
				if(wasCurrentWindow){
					this.closeInfoWindow();
					
					if(matchingSidePanels){
						matchingSidePanels.forEach(o => this.hideSidePanel(o));
						this.showFullMapCloseSidePanel();
					}
				}
				else if (this._currentInfoWindow == null || this._currentInfoWindow !== infoWindow) {
					if(isMobile() == false){
						infoWindow.open();
					}
					this._currentInfoWindow = infoWindow;

				}
				
			});
			marker.addListener('mouseover', () => {
				if(isMobile() == false){
					if (this._currentInfoWindow != null && this._currentInfoWindow !== infoWindow) {
						this.closeInfoWindow();
					}
					if (this._currentInfoWindow == null || this._currentInfoWindow !== infoWindow) {
						infoWindow.open();
						this._currentInfoWindow = infoWindow;
					}
				}
			});

            /*marker.addListener('mouseout', function() {
                infoWindow.close();
            });*/
		}
		this._locations.push(new MapsLocation(marker, markerClass));
	}

	private showSidePanel(sidePanel: HTMLElement){
		this._sidePanelElements.filter(o => o.id !== sidePanel.id).forEach(o => this.hideSidePanel(o));
		addClass(sidePanel,'is-visible');
		setTimeout(() => addClass(sidePanel,'is-active'), 10);
	}

	private hideSidePanel(sidePanel: HTMLElement){

		if(hasClass(sidePanel,'is-active')){
			addTransitionEndListener(sidePanel,() => {
				removeClass(sidePanel,'is-visible');
		   });
		   removeClass(sidePanel,'is-active');
		   //setTimeout(() => removeClass(sidePanel,'is-visible'), 350);
		}

	}

	private handleResize(): any {
		if(isMobile() == false){
			this.showFullMapCloseSidePanel();
		}
		else{
			//this.closeInfoWindow();
			//this._sidePanelElements.forEach(o => this.hideSidePanel(o));
		}
	}

	private showFullMapCloseSidePanel(){
		removeClass(this._mapWrapper,'is-map--small');
		const sidePanelClose = this._sidePanelWrapper.querySelector('.js-side-panel-close') as HTMLElement;
		if(sidePanelClose){
			sidePanelClose.click();
		}
		removeClass(this._searchContainer,'d-none');
		removeClass(this._sidePanelWrapper,'has--subpanel-open');
		if(isMobile()){
			this.centerMap(); 
			this.closeInfoWindow();

		}
	}

	private showHideMapMarkerClass(button) {
		const className = button.id;
		//toggleClass(button, this._options.mapMarkerClassesButtonActiveClass);
		//const visible = button.classList.contains(); // show if checked, otherwise hide
		if (className.length != null && className.length > 0) {
			this._options.showMapMarkerClasses = [className];
			this._markerCluster.clearMarkers();
			this.showOnlyLocationsWithCurrentFilter();
			this.centerMap();

			/*this._locations
				.filter(mapMarker => mapMarker.className === className)
				.forEach(mapMarker => this.showLocation(mapMarker));
			this._locations
				.filter(mapMarker => mapMarker.className !== className)
				.forEach(mapMarker => this.hideLocation(mapMarker));*/
		}
	}
	private search() {
		this._enableShowAllLocationsZoomOut = false;
		this.getSearchBounds().then(bounds => {
			this.showHideSearchBound(bounds);
			this._enableShowAllLocationsZoomOut = true;
		});
		if(this._searchClose){
			this._searchClose.click();
		}
	}

	private showHideSearchBound(bounds: google.maps.LatLngBounds, radius = this._minRadiusSearch) {
		const locationsNearby = this._locations.filter(location => (this._options.showMapMarkerClasses.indexOf(location.className) > -1) && (!bounds || bounds.contains(location.marker.getPosition())));
		if (locationsNearby.length > 0) {
			this._locations.forEach(location => {
				if (this._options.showMapMarkerClasses.indexOf(location.className) > -1) {
					if (!bounds || bounds.contains(location.marker.getPosition())
					) {
						this.showLocation(location);
					} else {
						this.hideLocation(location);
					}
				}

			});
			this.centerMap();

		}
		else {
			radius += 5;
			if (radius <= this._maxRadiusSearch) {
				bounds = this.addRadiusToBounds(
					bounds, radius
				)
				this.showHideSearchBound(bounds, radius)
			}
			else {
				console.log('no locations found in radius of ' + this._maxRadiusSearch + 'km');
				this.showOnlyLocationsWithCurrentFilter();
				this.centerMap();
			}
		}
	}

	private showOnlyLocationsWithCurrentFilter(){
		this._locations.forEach(location => {
			if (this._options.showMapMarkerClasses.indexOf(location.className) > -1) {
				this.showLocation(location);
			}
			else{
				this.hideLocation(location);
			}
		});
	}

	private showLocation(location: MapsLocation) {
		location.marker.setVisible(true)
		location.marker.setMap(this._map);
		this._oms.addMarker(location.marker);
		this._markerCluster.addMarker(location.marker);
	}

	private hideLocation(location: MapsLocation) {
		location.marker.setVisible(false)
		location.marker.setMap(null);
		this._oms.removeMarker(location.marker);
		this._markerCluster.removeMarker(location.marker);
		this.closeInfoWindow();
	}

	private centerMap() {
		if (this._locations && this._locations.length > 0) {
			const bounds = this.accumulateLocationBounds(
				this._locations.filter(l => l.marker.getVisible())
			);

			if (this._fitBoundsToSearchContainer && this._searchContainer && window.innerWidth >= 992) {
				const top = 250;
				const left = this._searchContainer.getBoundingClientRect().width + 60;
				const right = 30;
				const bottom = 30;

				fitBoundsWithPadding(this._map, bounds, { top, left, bottom, right });
			}
			else {
				this._map.fitBounds(bounds);

			}
			this.setZoom();
		}
	}

	private accumulateLocationBounds(locations: MapsLocation[]) {
		return locations.reduce(
			(bounds, l) => bounds.extend(l.marker.getPosition()),
			new google.maps.LatLngBounds()
		);
	}

	private getSearchBounds() {
		return new Promise<google.maps.LatLngBounds>(resolve => {
			const searchRequest = this.getGeoCoderSearchRequest();
			if (searchRequest && searchRequest.componentRestrictions && (searchRequest.componentRestrictions.postalCode || searchRequest.componentRestrictions.locality)) {
				if (searchRequest.componentRestrictions.postalCode === this._previousZip && searchRequest.componentRestrictions.locality == this._previousLocation) {
					resolve(
						this.addRadiusToBounds(
							this._previousBounds, this._minRadiusSearch
						)
					);
				} else {
					this._geoCoder.geocode(searchRequest, (results, status) => {
						if (status === google.maps.GeocoderStatus.OK) {
							const bounds = results[0].geometry.bounds || results[0].geometry.viewport;
							if (bounds) {
								this._previousZip = searchRequest.componentRestrictions.postalCode;
								this._previousLocation = searchRequest.componentRestrictions.locality;
								this._previousBounds = bounds;
								resolve(
									this.addRadiusToBounds(
										bounds, this._minRadiusSearch
									)
								);
							}
							else {
								resolve(null);
							}
						}
					});
				}
			} else {
				resolve(null);
			}
		});
	}

	private closeInfoWindow() {
		if (this._currentInfoWindow != null) {
			this._currentInfoWindowClickOpened = false;
			this._currentInfoWindow.close();
			this._currentInfoWindow = null;

		}
	}

	private setZoom() {
		if (this._map.getZoom() > this._options.maxZoom) {
			this._map.setZoom(this._options.maxZoom);
		}
	}

	private getGeoCoderSearchRequest() {
		const request: google.maps.GeocoderRequest = {};

		let zip = this._zipSearchField.value.trim();
		let location = this._locationSearchField.value.trim();
		//HACK --> geocoder has problem with 3000, 2500, 4000, 6000
		switch(zip){
			case "3000":
				location = "Bern";
				zip = ""; // with zip => this won't work!
				break;
			case "2500":
				location = "Biel";
				zip = ""; // with zip => this won't work!
				break;
			case "4000":
				location = "Basel";
				zip = ""; // with zip => this won't work!
				break;
			case "6000":
				location = "Luzern";
				zip = ""; // with zip => this won't work!
				break;
		}

		if (zip && location) {
			request.componentRestrictions = {
				postalCode: zip,
				locality: location,
				country: "CH"
			};
		}
		else if(zip){
			request.componentRestrictions = {
				postalCode: zip,
				country: "CH"
			};
		}
		else if (location){
			request.componentRestrictions = {
				locality: location
			};
		}

					

		return request;
	}

	private addRadiusToBounds(
		bounds: google.maps.LatLngBounds,
		radius = this._maxRadiusSearch
	) {
		const ne = google.maps.geometry.spherical.computeOffset(
			bounds.getNorthEast(),
			radius * 1000,
			45
		);
		const sw = google.maps.geometry.spherical.computeOffset(
			bounds.getSouthWest(),
			radius * 1000,
			225
		);
		return new google.maps.LatLngBounds(sw, ne);
	}
}

/*export function mapExtended(
    element: HTMLElement,
    options: MapExtendedOptions
): MapExtended {
    return new MapExtended(element, options);
}*/

